import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../../../assets/css/admin/adminauth/AdminLogin.css';

// Login ka call plain axios se ho raha hai (adminApi se nahi), kyunke
// adminApi.js ka interceptor login ke waqt token bhejne ki koshish karega
// jabke abhi token exist hi nahi karta.
const ADMIN_LOGIN_URL = 'http://localhost/Backend-SSQH/public/api/admin/login';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      Swal.fire({
        icon: 'error',
        title: 'Fields Incomplete',
        text: 'Please enter both email and password.',
      });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(ADMIN_LOGIN_URL, { email, password });

      // adminApi.js isi exact key ("admin_token") ko localStorage se
      // uthata hai aur har request ke Authorization header mein bhejta hai.
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_data', JSON.stringify(res.data.admin));

      Swal.fire({
        icon: 'success',
        title: 'Login Successful',
        timer: 1200,
        showConfirmButton: false,
      });

      navigate('/admin/profile');
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: err.response?.data?.message || 'Invalid email or password.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <h2>Admin Login</h2>
        <p className="admin-login-subtitle">Sign in to access the admin dashboard</p>

        <form onSubmit={handleLogin}>
          <div className="admin-login-field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              required
            />
          </div>

          <div className="admin-login-field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;